__turbopack_context__.v({
  "ownerAvatar__icon": "OwnerAvatar-module__kaLbxq__ownerAvatar__icon",
  "ownerAvatar__iconAdding": "OwnerAvatar-module__kaLbxq__ownerAvatar__iconAdding",
  "ownerAvatar__iconRemoving": "OwnerAvatar-module__kaLbxq__ownerAvatar__iconRemoving",
});
